module.exports = __webpack_public_path__ + "img/shopify.f038f666.jpg";